import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import { getPersonEvaluationsQuery } from "./queries";

const PersonBalancesheetContext = createContext({});

export const usePersonBalancesheetContext = () =>
  useContext(PersonBalancesheetContext);

export const PersonBalancesheetProvider = ({ ...props }) => {
  const [personEvaluations, setPersonEvaluations] = useState({});

  const getPersonEvaluation = useCallback(async ({ id }) => {
    try {
      setPersonEvaluations(
        await getPersonEvaluationsQuery({
          id,
        })
      );
    } catch (e) {
      console.error("getPersonEvaluation", e);
      throw e;
    }
  }, []);

  const values = useMemo(
    () => ({
      getPersonEvaluation,
      personEvaluations,
    }),
    [personEvaluations]
  );

  return <PersonBalancesheetContext.Provider value={values} {...props} />;
};
